<span [innerHTML]="clinic_Contact_No"></span>
<span [innerHTML]="clinic_Schedule"></span>
